(function ($) {
    $(function () {
        // region фиксированная шапка
        var stickyHeader = {
            header: null,
            headerTop: null,
            init: function () {
                this.header = $('#header');
                this.headerTop = this.header.offset().top;
            },
            activate: function () {
                $(window).on('scroll', this._onScroll);
            },
            deactivate: function () {
                $(window).off('scroll', this._onScroll);
                this._makeRegular();
            },
            _makeSticky: function () {
                this.header
                    .css({
                        position: 'fixed',
                        top: 0,
                        zIndex: 999
                    })
                    .addClass('sticky');
            },
            _makeRegular: function () {
                this.header
                    .css({
                        position: 'static'
                    })
                    .removeClass('sticky');
            },
            _onScroll: function () {
                var self = stickyHeader;
                if (!self.header.length) {
                    return true;
                }

                if (self.headerTop - ($('body').scrollTop() || $('html').scrollTop()) <= 0) {
                    self._makeSticky();
                } else {
                    self._makeRegular();
                }
            }
        };
        // endregion

        // region мобильное меню
        var mobileMenu = {
            menuResponsive: null,
            init: function () {
                $('#logo').before('' +
                    '<a href="#menu-main-responsive" class="d-inline-block d-md-none" id="menu-responsive-opener">' +
                    'МЕНЮ&nbsp;<span></span>' +
                    '</a>'
                );
                var menuClassicCopy = $('#main_menu')
                    .find('.menu')
                    .clone();

                menuClassicCopy
                    .wrap("<ul></ul>")
                    .find('li')
                    .each(function (i, e) {
                        $(e).removeAttr('class');
                    });

                this.menuResponsive = $('<nav id="menu-main-responsive"></nav>');
                this.menuResponsive.appendTo('body');
                menuClassicCopy.appendTo(this.menuResponsive);

                this.menuResponsive.mmenu(
                    {
                        navbars: [{
                            content: ["prev", "breadcrumbs", "close"]
                        }],
                        extensions: [
                            "position-right",
                            "theme-dark",
                            "pagedim-black",
                            "position-front"
                        ],
                        offCanvas: {
                            position: "right"
                        }
                    },
                    {
                        language: "ru"
                    }
                );
            },
            activate: function () {
            },
            deactivate: function () {

            },
        };
        // endregion

        // region карусели
        function CarouselClass(selector, params, beforeActivateCallback, afterDeactivateCallback) {
            this.init = function () {
            };

            this.activate = function () {
                if (typeof beforeActivateCallback === 'function') {
                    beforeActivateCallback();
                }
                $(selector).owlCarousel(params);
            };

            this.deactivate = function () {
                $(selector).trigger('destroy.owl.carousel');
                if (typeof afterDeactivateCallback === 'function') {
                    afterDeactivateCallback();
                }
            };
        }

        // endregion

        // region схема работы для страницы залог золота
        var schemeFix = {
            block: null,
            mainBlockId: null,
            init: function () {
                this.block = $('#gold_scheme, #tech_scheme');
                this.mainBlockId = 'views-comments';
            },
            activate: function () {
                this.block
                    .find('.views-row')
                    .wrapAll('<div id="' + this.mainBlockId + '"></div>');
            },
            deactivate: function () {
                this.block
                    .find('#' + this.mainBlockId)
                    .contents()
                    .unwrap();
            }
        };
        // endregion

        // region фиксы
        $(window).load(function () {
            $(window).trigger('scroll');
        });

        // добавочный класс блоку заголовка страницы
        $('.mblock')
            .filter(function () {
                return $('.bcrumbs', this).length;
            })
            .addClass('page-header');

        // добавочный класс страницам каталога
        $('body')
            .filter(function () {
                return $('#block-menu-menu-caatmeny', this).length
            })
            .addClass('page-catalog');
        // endregion

        // region медиа-запросы
        var queryXsSmMd = '(max-width: 1119px)';
        var queryXsSm = '(max-width: 767px)';
        var queryXs = '(max-width: 575px)';
        var queryMd = '(min-width: 768px) and (max-width: 1119px)';
        var querySm = '(min-width: 576px) and (max-width: 767px)';

        var prefsCarousel;
        var sellCarousels;
        enquire.register(queryXsSmMd, {
            setup: function () {
                // region блок распродажа
                sellCarousels = (function () {
                    var block = $('#main_sell');
                    return block
                        .find('.view-content')
                        .map(function (i, e) {
                            var id = 'mainSellBlockCarousel-' + i;
                            var selector = '#' + id;
                            return new CarouselClass(
                                selector,
                                {
                                    loop: true,
                                    margin: 10,
                                    responsiveClass: true,
                                    nav: true,
                                    dots: false,
                                    responsive: {
                                        0: {
                                            items: 1
                                        },
                                        425: {
                                            items: 2
                                        },
                                        576: {
                                            items: 3
                                        }
                                    }
                                },
                                function () {
                                    $(e).wrapInner('<div id="' + id + '" class="owl-carousel"></div>');
                                },
                                function () {
                                    $(e)
                                        .find(selector)
                                        .contents()
                                        .unwrap();
                                }
                            );
                        });
                })();
                // endregion
            },
            match: function () {
                sellCarousels.map(function (i, e) {
                    e.activate();
                });
            },
            unmatch: function () {
                sellCarousels.map(function (i, e) {
                    e.deactivate();
                });
            }
        });

        enquire.register(queryXsSm, {
            setup: function () {
                mobileMenu.init();
                stickyHeader.init();
                // region блок преимуществ
                prefsCarousel = (function () {
                    var block = $('#main_pref');
                    var id = 'mainPrefCarousel';
                    var selector = '#' + id;
                    return new CarouselClass(
                        selector,
                        {
                            loop: true,
                            margin: 10,
                            responsiveClass: true,
                            nav: true,
                            dots: false,
                            responsive: {
                                0: {
                                    items: 1,
                                    nav: false,
                                },
                                421: {
                                    items: 2,
                                }
                            }
                        },
                        function () {
                            block
                                .find('.content')
                                .wrapInner('<div id="' + id + '" class="owl-carousel"></div>');
                        },
                        function () {
                            block
                                .find(selector)
                                .contents()
                                .unwrap();
                        }
                    );
                })();
                // endregion
                schemeFix.init();
            },
            match: function () {
                mobileMenu.activate();
                stickyHeader.activate();
                prefsCarousel.activate();
                schemeFix.activate();
            },
            unmatch: function () {
                mobileMenu.deactivate();
                stickyHeader.deactivate();
                prefsCarousel.deactivate();
                schemeFix.deactivate();
            }
        });
        // endregion
    });
})(jQuery.noConflict(true));
